// export const localURL = "http://localhost:8080/"
export const localURL = "https://auth-router-bsqr.onrender.com/"